import { reportingGroupFieldProps } from 'components/fields/ReportingGroupField';
import { createEntityFilterChip } from 'components/filters/createEntityFilterChip';

export const ReportingGroupFilterChip = createEntityFilterChip('reporting/groups/', {
  getOptionLabel: reportingGroupFieldProps.getOptionLabel,
  getOptionValue: reportingGroupFieldProps.getOptionValue,
});
